export function defaultExceptionHandler(err){return Promise.reject(err.message)}